import { Container, Grid, Typography, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import Page from "../../../components/layouts/Page";
import bg from "../../../assets/fons/background_fost.jpg";
import img from "../../../assets/headers/protagonistes.jpeg";
import Header from "../../../components/layouts/Header";
import { useTranslation } from "react-i18next";
import { ReactComponent as Simbol1 } from "../../../assets/simbols/simbol3.svg";
import alpaca from "../../../assets/img/alpaca-cap-2.png";
import CustomButton from "../../../components/CustomButton";
import theme from "../../../theme";
import PetFriendlySeal from "../../../components/PetFriendlySeal";

const Espai = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const matches = useMediaQuery("(min-width:960px)");
    const claimPrefix = t("espai_claim_prefix");
    const claimHighlight = t("espai_claim_highlight");
    const description = t("espai_descr");
    const petFriendly = t("pet_friendly");
    const portaMascota = t("porta_mascota");

    return (
        <Page title={"Merolla de Berguedà - " + t("espai")}>
            <Header title={t("espai")} img={img} />

            <Box className={classes.main}>
                <Container maxWidth="md" style={{ zIndex: 1 }}>
                    <Box className={classes.videoWrap}>
                        <video className={classes.video} controls controlsList="nodownload" autoPlay muted loop playsInline>
                            <source src="/entorn.webm" type="video/webm" />
                            El teu navegador no suporta la reproducció de vídeo.
                        </video>
                    </Box>

                    <Grid container spacing={4} display="flex" justifyContent={"center"} alignItems={"center"}>
                        {matches && (
                            <Grid item md={6} xs={12} Box style={{ position: "relative", display: "inline-block" }}>
                                <Box className={classes.imgWrap}>
                                    <img src="/espai_merolla.webp" alt="Merolla de Berguedà" className={classes.img} />
                                </Box>
                                <Box
                                    style={{
                                        transform: "rotate(-10deg)",
                                        position: "absolute",
                                        left: -10,
                                        top: -110,
                                    }}
                                >
                                    <PetFriendlySeal labelTop={petFriendly} labelBottom={portaMascota} />
                                </Box>
                            </Grid>
                        )}
                        <Grid item md={matches ? 6 : 12} xs={12} position="relative">
                            <Simbol1 className={matches ? classes.simbol1 : classes.simbol1_m} />
                            <Typography variant="h2" mb={3}>
                                {claimPrefix} <span style={{ color: theme.color.primary }}>{claimHighlight}</span>
                            </Typography>
                            <Typography variant="body1" mb={3} className={classes.description}>
                                {description}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Box textAlign={"center"}>
                        <CustomButton title={t("mapa")} onClick={() => window.open("https://maps.app.goo.gl/LragCjsmBWBGihgu8", "_blank", "noopener")} />
                    </Box>
                    {!matches && (
                        <Box display="flex" justifyContent="center" mt={4}>
                            <PetFriendlySeal labelTop={petFriendly} labelBottom={portaMascota} />
                        </Box>
                    )}

                    {matches && <img src={alpaca} alt="Merolla de Berguedà" className={classes.alpaca} />}
                </Container>
            </Box>
        </Page>
    );
};

export default Espai;

const useStyles = makeStyles((theme) => ({
    main: {
        background: `url(${bg})`,
        display: "flex",
        paddingTop: 100,
        paddingBottom: 200,
        flexDirection: "column",
        position: "relative",
        zIndex: 0,
    },
    videoWrap: {
        width: "100%",
        position: "relative",
        borderRadius: 16,
        overflow: "hidden",
        boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
        backgroundColor: theme.palette.background.paper,
        marginBottom: 150,
    },
    video: {
        width: "100%",
        display: "block",
    },
    description: {
        lineHeight: 1.6,
    },
    badgeRow: {
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "center",
        flexWrap: "wrap",
        justifyContent: "flex-start",
    },
    simbol1: {
        width: 60,
        fill: theme.color.secondary,
        position: "absolute",
        left: -30,
        top: 0,
        transform: "rotate(-10deg)",
    },
    simbol1_m: {
        width: 60,
        fill: theme.color.secondary,
        position: "absolute",
        left: 0,
        top: -30,
        transform: "rotate(-10deg)",
    },
    alpaca: {
        position: "absolute",
        width: 380,
        right: 0,
        bottom: 0,
        opacity: 0.9,
    },
    seal: {
        width: 140,
        height: 140,
    },
    sealCircle: {
        fill: "none",
        stroke: theme.color.primary,
        strokeWidth: 6,
        strokeDasharray: "8 6",
    },
    sealInner: {
        fill: theme.palette.background.paper,
        stroke: theme.color.secondary,
        strokeWidth: 3,
    },
    sealText: {
        fontFamily: "Raleway, sans-serif",
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: 1,
        fill: theme.palette.text.primary,
    },
    sealIcon: {
        width: 40,
        height: 40,
        transform: "translate(-20px, -20px)",
        color: theme.color.primary,
    },
    imgWrap: {
        width: "100%",
        maxWidth: 450,
        margin: "0 auto",
        borderRadius: 18,
        overflow: "hidden",
        boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
    },
    img: {
        width: "100%",
        display: "block",
        objectFit: "cover",
    },
}));
